"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectManagementSaveUserModalComponent = exports.ConnectManagementSaveUserModalComponentContext = void 0;
const core_1 = require("@angular/core");
const bootstrap_1 = require("angular2-modal/plugins/bootstrap");
const angular2_modal_1 = require("angular2-modal");
const connect_user_1 = require("./connect-user");
const _ = require("lodash");
const forms_1 = require("@angular/forms");
class ConnectManagementSaveUserModalComponentContext extends bootstrap_1.BSModalContext {
}
exports.ConnectManagementSaveUserModalComponentContext = ConnectManagementSaveUserModalComponentContext;
let ConnectManagementSaveUserModalComponent = class ConnectManagementSaveUserModalComponent {
    constructor(dialog) {
        this.dialog = dialog;
        this.placeholder = "Passsword";
        this.success = false;
        this.context = dialog.context;
        this.user = new connect_user_1.ConnectUser(_.cloneDeep(this.context.user));
        this.title = this.user.id ? "Update User" : "Create User";
        this.subtitle = this.user.id ? this.user.email : "";
        this.placeholder = this.user.id ? "Unchanged" : "Password";
        if (!this.user.id) {
            this.generatePassword();
        }
    }
    ngOnInit() {
        this.form = new forms_1.FormGroup({
            email: new forms_1.FormControl("email"),
            password: new forms_1.FormControl("password"),
        });
    }
    generatePassword() {
        this.user.generatePassword();
    }
    onPasswordChanged(password) {
        if (!password) {
            this.user.password = null;
        }
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            this.error = null;
            try {
                yield this.user.save();
                this.success = true;
            }
            catch (err) {
                if (err.user) {
                    this.existing = err.user;
                    return;
                }
                this.error = err;
            }
        });
    }
    cancelReassignment() {
        return __awaiter(this, void 0, void 0, function* () {
            this.existing = null;
        });
    }
    confirmReassignment() {
        return __awaiter(this, void 0, void 0, function* () {
            this.error = null;
            let user = new connect_user_1.ConnectUser({
                id: this.existing.id,
                organization: this.user.organization,
            });
            try {
                yield user.save();
                this.dialog.close({ saved: true });
            }
            catch (err) {
                this.error = err;
            }
        });
    }
    acknowledgeCredentials() {
        return __awaiter(this, void 0, void 0, function* () {
            this.dialog.close({ saved: true });
        });
    }
    showForm() {
        return !this.existing && !this.success;
    }
    showConflict() {
        return !!this.existing && !this.success;
    }
    showCredentials() {
        return this.success;
    }
};
exports.ConnectManagementSaveUserModalComponent = ConnectManagementSaveUserModalComponent;
exports.ConnectManagementSaveUserModalComponent = ConnectManagementSaveUserModalComponent = __decorate([
    (0, core_1.Component)({
        selector: "connect-management-save-user-modal",
        templateUrl: "app/connect-management-save-user-modal.component.html",
    }),
    __metadata("design:paramtypes", [angular2_modal_1.DialogRef])
], ConnectManagementSaveUserModalComponent);
//# sourceMappingURL=connect-management-save-user-modal.component.js.map